export enum NotificationGroup {
  Doctors = 'doctor-notifications',
  ChannelingPartners = 'channeling-partner-notifications',
}
